import { REMOVE_RSS_ITEMS_ROWS } from './actionTypes';

const removeRssItemsRows = parentId => ({
    type: REMOVE_RSS_ITEMS_ROWS,
    payload: parentId,
});

export default removeRssItemsRows;
